import { render } from "./RepairReturnProductForm.vue?vue&type=template&id=6d331f84&scoped=true"
import script from "./RepairReturnProductForm.vue?vue&type=script&lang=js"
export * from "./RepairReturnProductForm.vue?vue&type=script&lang=js"

import "./RepairReturnProductForm.vue?vue&type=style&index=0&id=6d331f84&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d331f84"]])

export default __exports__